import PropTypes from 'prop-types';
import './Detail.css';

// 항목명-값 목록. 값이 비어 있으면 —를 보여준다.
export default function InfoList({ items }) {
    return (
        <dl className="admin-info-list">
            {items.map(item => (
                <div key={item.label}>
                    <dt>{item.label}</dt>
                    <dd>{item.value ?? '—'}</dd>
                </div>
            ))}
        </dl>
    );
}

InfoList.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.node,
    })).isRequired,
};
